import CryptoJS from 'crypto-js';

class AesUtil {

    constructor(key = 'my-secret-key-2024', iv = '1234567890123456') {
        // 将密钥和IV转换为CryptoJS格式
        this.key = CryptoJS.enc.Utf8.parse(key);
        this.iv = CryptoJS.enc.Utf8.parse(iv);
        this.algorithm = 'AES';
        this.mode = CryptoJS.mode.CBC;
        this.padding = CryptoJS.pad.Pkcs7;
    }

    /**
   * AES加密
   * @param {string} text - 要加密的文本
   * @returns {string} 加密后的Base64字符串
   */
    encrypt(text) {
        try {
            const encrypted = CryptoJS.AES.encrypt(text, this.key, {
                iv: this.iv,
                mode: this.mode,
                padding: this.padding
            });
            return encrypted.toString();
        } catch (error) {
            throw new Error('AES加密失败: ' + error.message);
        }
    }
    decrypt(text) {
        try {
            const decrypted = CryptoJS.AES.decrypt(encryptedText, this.key, {
                iv: this.iv,
                mode: this.mode,
                padding: this.padding
            });
            return decrypted.toString(CryptoJS.enc.Utf8);
        } catch (error) {
            throw new Error('AES解密失败: ' + error.message);
        }
    }

    /**
     * 生成带时间戳的认证信息
     * @param {string} username - 用户名
     * @param {string} password - 密码
     * @returns {Object} 认证头对象
     */
    generateAuthData(username, password) {
        const timestamp = Date.now();
        const credentials = `${username}:${password}:${timestamp}`;
        const encryptedData = this.encrypt(credentials);

        // 在浏览器环境中，使用btoa进行Base64编码
        const base64Encoded = btoa(encryptedData);

        return {
            encryptedData: encryptedData,
            timestamp: timestamp,
            authHeader: `Basic ${base64Encoded}`,
            headers: {
                'Authorization': `Basic ${base64Encoded}`,
                'X-Timestamp': timestamp.toString(),
                'X-Encrypted': 'true',
                'Content-Type': 'application/json'
            }
        };
    }
}

const aesUtil = new AesUtil(import.meta.env.VITE_APP_APP_TOKEN_KEY, import.meta.env.VITE_APP_APP_TOKEN_IV);
export default aesUtil